import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.observeInstructorLocationForm();
  }

  observeInstructorLocationForm() {
    const instructorLocationContainer = document.getElementById(
      "school_quick_look_add_lesson_instructor_and_location_form"
    );

    if (instructorLocationContainer) {
      this.observer = new MutationObserver(() => {
        this.checkForLocationEdit();
      });

      this.observer.observe(instructorLocationContainer, {
        childList: true,
        subtree: true,
      });
    }
  }

  checkForLocationEdit() {
    const locationEditForm = document.getElementById(
      "quicklook-schedule-location-edit"
    );
    const saveButtonContainer = document.getElementById(
      "school-lesson-quick-look-lesson-save-button"
    );

    if (saveButtonContainer) {
      const saveButton = saveButtonContainer.querySelector("button");

      if (saveButton) {
        if (locationEditForm) {
          saveButton.setAttribute("disabled", "disabled");
        } else {
          saveButton.removeAttribute("disabled");
        }
      }
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  async editLesson(event) {
    event.preventDefault();

    const lesson_id = 45;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
  }

  closeQuickLook(event) {
    event.preventDefault();

    const quickViewElement = document.querySelector(
      "#school-dashboard-lesson-quick-look"
    );
    quickViewElement.classList.add("u-hidden");
  }

  hideTestDetails(event) {
    event.preventDefault();

    const formElement = document.getElementById("test_details_form");
    formElement.setAttribute("hidden", true);

    const formElementStudent = document.getElementById(
      "quick-look-student-book-dropdown"
    );
    formElementStudent.removeAttribute("hidden");

    const formElementSlot = document.getElementById("add-open-slots-form");
    formElementSlot.setAttribute("hidden", true);

    const formElementPickupTime = document.getElementById(
      "add-lesson-pickup-time-form"
    );
    formElementPickupTime.removeAttribute("hidden");

    const formElementSaveButton = document.getElementById(
      "school-lesson-quick-look-lesson-save-button"
    );
    formElementSaveButton.removeAttribute("hidden");

    const formElementScheduleClassroom = document.querySelector(
      "#schedule-classroom-program-form"
    );
    formElementScheduleClassroom.classList.add("u-hidden");

    // lesson_new_duration_in_minutes select element
    const lessonNewDurationInput = document.getElementById(
      "new_lesson_specific_duration_in_minutes"
    );
    if (lessonNewDurationInput) {
      // Remove the first option
      const firstOption = lessonNewDurationInput.querySelector("option");
      if (firstOption && firstOption.value === "0") {
        firstOption.remove();
      }
    }

    const startDateLabel = document.querySelector('label[for="start_time"]');
    if (startDateLabel) {
      startDateLabel.textContent = "Start time";
    }

    const durationLabel = document.querySelector(
      'label[for="new_lesson_specific_duration_in_minutes"]'
    );
    if (durationLabel) {
      durationLabel.textContent = "Duration";
    }

    // update new_lesson_specific_duration_in_minutes with the value in default_driving_lesson_length_in_minutes
    const defaultDrivingLessonLength = document.getElementById(
      "default_driving_lesson_length_in_minutes"
    );
    if (defaultDrivingLessonLength) {
      const newLessonDurationInput = document.getElementById(
        "new_lesson_specific_duration_in_minutes"
      );
      if (newLessonDurationInput) {
        const lessonLength = parseInt(
          defaultDrivingLessonLength.textContent.trim()
        );

        // Set the value and trigger change event to ensure it updates visually
        newLessonDurationInput.value = lessonLength;
        newLessonDurationInput.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }
    }
  }

  unhideTestDetails(event) {
    event.preventDefault();

    const formElement = document.getElementById("test_details_form");
    formElement.removeAttribute("hidden");

    const formElementStudent = document.getElementById(
      "quick-look-student-book-dropdown"
    );
    formElementStudent.removeAttribute("hidden");

    const formElementPickupTime = document.getElementById(
      "add-lesson-pickup-time-form"
    );
    formElementPickupTime.removeAttribute("hidden");

    const formElementSaveButton = document.getElementById(
      "school-lesson-quick-look-lesson-save-button"
    );
    formElementSaveButton.removeAttribute("hidden");

    const formElementSlot = document.getElementById("add-open-slots-form");
    formElementSlot.setAttribute("hidden", false);

    const formElementScheduleClassroom = document.querySelector(
      "#schedule-classroom-program-form"
    );
    formElementScheduleClassroom.classList.add("u-hidden");

    // lesson_new_duration_in_minutes select element
    const lessonNewDurationInput = document.getElementById(
      "new_lesson_specific_duration_in_minutes"
    );
    if (lessonNewDurationInput) {
      // Add an option for 0 minutes at the start
      const option = document.createElement("option");
      option.value = "0";
      option.textContent = "0 minutes (no pretest)";
      lessonNewDurationInput.prepend(option);
    }

    const startDateLabel = document.querySelector('label[for="start_time"]');
    if (startDateLabel) {
      startDateLabel.textContent = "Pre-Test start";
    }

    const durationLabel = document.querySelector(
      'label[for="new_lesson_specific_duration_in_minutes"]'
    );
    if (durationLabel) {
      durationLabel.textContent = "Pre-Test duration";
    }

    // update new_lesson_specific_duration_in_minutes with the value in default_driving_test_length_in_minutes
    const defaultDrivingTestLength = document.getElementById(
      "default_driving_test_length_in_minutes"
    );
    if (defaultDrivingTestLength) {
      const newLessonDurationInput = document.getElementById(
        "new_lesson_specific_duration_in_minutes"
      );
      if (newLessonDurationInput) {
        const testLength = parseInt(
          defaultDrivingTestLength.textContent.trim()
        );

        // Set the value and trigger change event to ensure it updates visually
        newLessonDurationInput.value = testLength;
        newLessonDurationInput.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }
    }
  }

  setupSlotDetails(event) {
    event.preventDefault();

    const formElement = document.getElementById(
      "quick-look-student-book-dropdown"
    );
    formElement.setAttribute("hidden", true);

    const formElementTest = document.getElementById("test_details_form");
    formElementTest.setAttribute("hidden", true);

    const formElementSlot = document.getElementById("add-open-slots-form");
    formElementSlot.removeAttribute("hidden");

    const formElementPickupTime = document.getElementById(
      "add-lesson-pickup-time-form"
    );
    formElementPickupTime.removeAttribute("hidden");

    const formElementSaveButton = document.getElementById(
      "school-lesson-quick-look-lesson-save-button"
    );
    formElementSaveButton.setAttribute("hidden", true);

    const formElementInstructor = document.getElementById(
      "school_quick_look_add_lesson_instructor_and_location"
    );
    formElementInstructor.setAttribute("hidden", true);

    const formElementScheduleClassroom = document.querySelector(
      "#schedule-classroom-program-form"
    );
    formElementScheduleClassroom.classList.add("u-hidden");
  }

  setupScheduleClassroom(event) {
    event.preventDefault();

    // const formElement = document.getElementById('quick-look-student-book-dropdown');
    // formElement.setAttribute('hidden', true);

    const formElementTest = document.getElementById("test_details_form");
    formElementTest.setAttribute("hidden", true);

    const formElementSlot = document.getElementById("add-open-slots-form");
    formElementSlot.setAttribute("hidden", true);

    const formElementInstructor = document.getElementById(
      "school_quick_look_add_lesson_instructor_and_location"
    );
    formElementInstructor.setAttribute("hidden", true);

    const formElementPickupTime = document.getElementById(
      "add-lesson-pickup-time-form"
    );
    formElementPickupTime.setAttribute("hidden", true);

    const formElementSaveButton = document.getElementById(
      "school-lesson-quick-look-lesson-save-button"
    );
    formElementSaveButton.setAttribute("hidden", true);

    const formElementStudent = document.getElementById(
      "quick-look-student-book-dropdown"
    );
    formElementStudent.removeAttribute("hidden");

    // show schedule-classroom-program-form
    const formElementScheduleClassroom = document.querySelector(
      "#schedule-classroom-program-form"
    );
    formElementScheduleClassroom.classList.remove("u-hidden");
  }
}
